// extracted by mini-css-extract-plugin
module.exports = {"cart-items":"Cart_cart-items___qbUk","total":"Cart_total__K3OVY","actions":"Cart_actions__1ow-4","button--alt":"Cart_button--alt__29TxR","button":"Cart_button__3qgbN"};